import React, { useState, useEffect } from 'react';
import { get, post } from '../Services/http';

const MyPageEnjoyClubCollapse = ({
  bonusNotMember,
  bonusAvailableLabel,
  bonusAvailable,
  bonusTitle,
  bonusDescription,
  bonusImageUrl,
  bonusSignOut,
  bonusSignUp,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMember, setIsMember] = useState(false);

  const [currentAvailableBonus, setCurrentAvailableBonus] = useState(bonusAvailable);

  useEffect(() => {
    checkMemberShipStatus();
  }, []);

  async function checkMemberShipStatus() {
    try {
      const response = await get('/api/enjoyClub/check');
      const data = await response.json();
      setIsMember(data.isMember);
      setCurrentAvailableBonus(data.availableBonus);
    } catch (err) {
      console.error('Error fetching Enjoy Club membership', err.message);
    }
  }

  async function onMembershipChange() {
    try {
      if (isMember) {
        await post('/api/enjoyClub/signOut');
      } else {
        await post('/api/enjoyClub/signUp');
      }
      checkMemberShipStatus();
    } catch (err) {
      console.error('Error updating Enjoy Club membership', err.message);
    }
  }

  return (
    <div className="column current-bonus-wrapper">
      <div className="row small-12 medium-12 current-bonus">
        <div className="small-12 medium-6 bonus-logo-wrapper">
          <img className="bonus-logo" src={bonusImageUrl} alt={bonusTitle} />
          {isMember ? (
            <label className="my-page__label color-black bonus-text">
              {`${bonusAvailableLabel}: ${currentAvailableBonus}`}
            </label>
          ) : (
            <label className="my-page__label color-black bonus-text">
              {bonusNotMember}
            </label>
          )}
        </div>
        <div className="small-12 medium-6 column bonus-action-wrapper">
          <div className="bonus-membership-update">
            <button className="button" onClick={onMembershipChange}>
              {isMember ? bonusSignOut : bonusSignUp}
            </button>
          </div>
          <div
            className={`collapse-block__header ${
              isOpen ? 'collapse-block__header-open' : ''
            }`}
            onClick={(_) => setIsOpen(!isOpen)}
          >
            {bonusTitle}
          </div>
        </div>
      </div>
      <div
        className={`row small-12 medium-12 collapse-block__content ${
          isOpen ? 'collapse-block__content-open' : ''
        }`}
      >
        {bonusDescription && (
          <div
            className="row"
            dangerouslySetInnerHTML={{
              __html: bonusDescription,
            }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default MyPageEnjoyClubCollapse;
